module.exports = __webpack_public_path__ + "static/media/oliver-levy-webDev.20498a8b.jpg";